module.exports = __webpack_public_path__ + "static/media/webdesign-services-img63.f41f870c.jpg";